module.exports = __webpack_public_path__ + "static/img/1.b569566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/1.jpg
// module id = clxy
// module chunks = 69